export default {
  SET_TERMS(state, terms) {
    state.terms = terms;
  },
  SET_NEW_CUSTOM_TERM(state, { termId, id, language, name }) {
    try {
      state.terms.find(item => item.termId === termId).customTerms.push({ id, language, name });
    } catch (err) {
      console.error(err);
    }
  },
  SET_NEW_VALUE(state, { termId, customTermId, name }) {
    try {
      state.terms.find(item => item.termId === termId).customTerms.find(item => item.id === customTermId).name = name;
    } catch (err) {
      console.error(err);
    }
  }
};
